import { Injectable, signal, computed } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingSpinnerService {
  private isLoadingSignal = signal<boolean>(false);
  public isLoading = computed(() => this.isLoadingSignal());

  show(): void {
    this.isLoadingSignal.set(true);
  }

  hide(): void {
    this.isLoadingSignal.set(false);
  }
}